import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';
import { enpointCervinoWeb } from './../../configuration/enpointsCervino';
import { InvoiceConceptModel } from './../../models/invoicing/invoice-concept.model';

@Injectable({
  providedIn: 'root'
})
export class InvoiceConceptService {

  constructor(private _httpClient: HttpClient) { }

  getInvoiceConceptById(invoiceConceptId: number): Observable<InvoiceConceptModel> {
    return this._httpClient.get<InvoiceConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.GetInvoiceConceptById}/${invoiceConceptId}`);
  }

  geInvoicetConceptsByInvoiceId(invoiceId: number): Observable<Array<InvoiceConceptModel>> {
    return this._httpClient.get<Array<InvoiceConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.GetInvoiceConceptsByInvoiceId}/${invoiceId}`);
  }

  saveGeneralDiscount(invoiceConceptContract: InvoiceConceptModel): Observable<InvoiceConceptModel> {
    return this._httpClient.post<InvoiceConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.SaveGeneralDiscount}`,
      invoiceConceptContract);
  }

  getReteFuenteByInvoiceAndConcept(nvoiceId: number, conceptInvoicingId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.GetReteFuenteByInvoiceAndConcept}/${nvoiceId}/${conceptInvoicingId}`);
  }

  getReteIcaByInvoiceAndConcept(nvoiceId: number, conceptInvoicingId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.GetReteIcaByInvoiceAndConcept}/${nvoiceId}/${conceptInvoicingId}`);
  }

  getBaseIvaByInvoiceAndConcept(invoiceId: number, conceptInvoicingId: number): Observable<{ ivaValue: number; ivaRate: string }> {
    return this._httpClient.get<{ ivaValue: number; ivaRate: string }>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.GetBaseIvaByInvoiceAndConcept}/${invoiceId}/${conceptInvoicingId}`);
  }

  getColumnsForConceptConsultation(): Observable<FilterGlobalResponseModel> {
    return this._httpClient.get<FilterGlobalResponseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.GetColumnsForConceptConsultation}`);
  }

  getColumnsForInvoiceDiscountConceptAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.GetColumnsForInvoiceDiscountConceptAsync}`);
  }

  getAllInvoiceConceptsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, storeConsolidated: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('storeConsolidated', storeConsolidated);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.GetAllInvoiceConceptsWithPagination}`,
      filters, { params: params }
    );
  }

  getInvoiceConceptsByInvoiceIdWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, invoiceId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('invoiceId', invoiceId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.GetInvoiceConceptsByInvoiceIdWithPagination}`,
      { params: params }
    );
  }

  exportConceptConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, storeConsolidated: boolean,): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString())
      .set('storeConsolidated', storeConsolidated);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.ExportConceptConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getConceptInvoicingCodeNameById(conceptInvoicingById: number): Observable<{ code: string; name: string }> {
    return this._httpClient.get<{ code: string; name: string }>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceConcept.GetConceptInvoicingCodeNameByIdAsync}/${conceptInvoicingById}`);
  }

}
